export const INTEGRATIONS_IRONCLAD = 'integrations.ironclad' as const;
export const FEATURE_IMPORT_VIA_FILE = 'feature.importviafile' as const;
export const FEATURE_WORKFLOW_DISABLE_DELETE_ACCESS =
  'feature.workflow.disabledeleteaccess' as const;
export const FEATURE_DISNEY_GEO_FOOTER = 'feature.disney.geofooter' as const;
export const FEATURE_STUDIO_COMMENTS = 'feature.studio.comments' as const;
export const FEATURE_WORKFLOW_CHANGE_ASSESSMENT_STATUS =
  'feature.workflow.changeassessmentstatus' as const;
export const FEATURE_WORKFLOW_VIBEFLOWING =
  'feature.workflow.vibeflowing' as const;
export const FEATURE_E_SIGN_CERTIFICATE = 'feature.eSignCertificate' as const;
export const INTEGRATIONS_ESIGNATURE_SPLIT =
  'integrations.esignature-split' as const;
export const FEATURE_WORKFLOW_ESIGNATURE_EMBEDDED =
  'feature.workflow.esign-embedded' as const;
export const FEATURE_WORKFLOW_EMBEDDED_RECIPIENT_SIGNING =
  'feature.workflow.embeddedRecipientSigning' as const;
export const FEATURE_TWO_FACTOR_AUTHENTICATION = 'feature.auth.2fa' as const;
export const FEATURE_PARTNER_API_KEYS = 'feature.partnerapikeys' as const;
export const FEATURE_TICKETING_EXPORT_DATA =
  'feature.ticketing.exportData' as const;
export const FEATURE_TICKETING_SUBNAVIGATION =
  'feature.ticketing.subnavigation' as const;
export const FEATURE_TICKETING_AUDIT_PORTAL =
  'feature.ticketing.auditportal' as const;
export const FEATURE_TOP_LEVEL_REPORTING =
  'feature.top-level-reporting' as const;
export const FEATURE_TICKETING_COLLABORATORS_ENABLED =
  'feature.ticketing.collaborators.enabled' as const;
export const FEATURE_TICKETING_MESSAGE_TIMELINE =
  'feature.ticketing.messageTimeline' as const;
export const FEATURE_AI_STATUS_GUIDANCE = 'feature.ai.statusguidance' as const;
export const FEATURE_AI_AGENT_GUIDANCE = 'feature.ai.agent-guidance' as const;
export const FEATURE_AI_AGENT_PROMPT = 'feature.ai.agent-prompt' as const;
export const FEATURE_AI_AGENTIC_LOOP = 'feature.ai.agentic-loop' as const;
export const FEATURE_START_BLOCK_EXTRA_FIELDS =
  'feature.startblock.extrafields' as const;
export const FEATURE_ESIGN_ACCOUNT_NAME = 'feature.esign.accountname' as const;
export const FEATURE_STUDIO_AI_JS_BLOCK = 'feature.studio.aiJsBlock' as const;
export const FEATURE_WORKFLOW_FORM_MULTISELECT_FIELD =
  'feature.workflow.form.multiselectfield' as const;
export const FEATURE_ESIGN_SIGNED_DATE_FORMAT =
  'feature.esign.signedDateFormat' as const;
export const FEATURE_ESIGN_REPLACE_RTE = 'feature.esign.replaceRTE' as const;
export const FEATURE_TICKETING_TASKS_AND_CALENDAR_EVENTS =
  'feature.ticketing.tasks_and_calendar_events' as const;
export const FEATURE_TICKETING_MATTER_HISTORY =
  'feature.ticketing.matter_history' as const;
export const FEATURE_TICKETING_UPDATE_TICKET_MESSAGE =
  'feature.ticketing.updateticketmessage' as const;
export const FEATURE_TICKETING_REORDER_VIEWS =
  'feature.ticketing.reorderViews' as const;
export const FEATURE_TICKETING_ONBOARDING_WIZARD =
  'feature.ticketing.onboardingwizard' as const;
export const FEATURE_TICKETING_REQUESTER_PORTAL_COLUMN_CONFIG =
  'feature.ticketing.requesterPortal.columnConfig' as const;
export const FEATURE_TICKETING_REQUESTER_PORTAL_VISIBILITY =
  'feature.ticketing.requesterPortal.visibility' as const;

export const FEATURE_FORM_JS_MIDDLEWARE_STATE_RESET =
  'feature.form.jsMiddlewareStateReset' as const;
export const FEATURE_STUDIO_CHANGE_ASSESSMENT_STATUS_ENHANCEMENTS =
  'feature.studio.changeAssessmentStatusEnhancements' as const;

export const FEATURE_USER_BY_ID_AUTH_SERVICE =
  'feature.auth.user-by-id' as const;

// TODO DEV-21196: remove flag constant once auth-frontend cutover is complete
export const FEATURE_AUTH_FRONTEND_CUTOVER =
  'feature.auth.frontend-cutover' as const;

export const LOGIN_SAFE_REDIRECT = 'login.safeRedirect' as const;

// For dev only
export const INTEGRATIONS_IRONCLAD_DEV = 'integrations.ironclad.dev' as const;

export const FEATURE_ACCOUNT_CREATE_IN_AUTH =
  'feature.account.createinauth' as const;
